import React from "react";
import { useNavigate } from "react-router";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { smallShadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { CategoryCardType } from "../types";

interface CategoryCardProps {
  item: CategoryCardType;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ item }) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate(item.route);
  };

  return (
    <CategoryCardContainer onClick={handleOnClick}>
      <Images>
        <BackgroundCard />
        <CardImage src={item.image} />
      </Images>
      <Title className="text-body">{item.title}</Title>
    </CategoryCardContainer>
  );
};

const Images = styled.div`
  position: relative;
  margin: 10px;
  height: 185px;
  width: 240px;

  @media only screen and (${device.tablet}) {
    margin: 10px 20px;
    height: 200px;
    width: 260px;
  }

  @media only screen and (${device.laptopL}) {
    height: 245px;
    width: 320px;
  }
`;

const BackgroundCard = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 220px;
  height: 165px;
  background-color: ${colors.newGray};

  @media only screen and (${device.tablet}) {
    width: 240px;
    height: 180px;
  }

  @media only screen and (${device.laptopL}) {
    width: 300px;
    height: 225px;
  }
`;
const CardImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 20px;
  width: 220px;
  height: 165px;
  ${smallShadow};
  filter: brightness(95%);

  background-color: ${colors.grayest};

  @media only screen and (${device.tablet}) {
    width: 240px;
    height: 180px;
  }

  @media only screen and (${device.laptopL}) {
    width: 300px;
    height: 225px;
  }
`;

const Title = styled.div`
  text-align: center;
  height: 60px;

  @media only screen and (${device.tablet}) {
    text-align: left;
    margin-left: 20px;
  }

  @media only screen and (${device.laptop}) {
    text-align: left;
  }
`;
const CategoryCardContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  place-self: center;
  width: 260px;
  cursor: pointer;

  @media only screen and (${device.tablet}) {
    width: 280px;
  }

  @media only screen and (${device.laptop}) {
    &:hover {
      ${CardImage} {
        filter: brightness(100%);
        transition: 0.3s;
        transform: scale(1.05);
        ${smallShadow};
      }
    }
  }
  @media only screen and (${device.laptopL}) {
    justify-content: flex-start;
    width: 340px;
  }
`;
export default CategoryCard;
